import React, { useEffect } from "react";
import { tokens } from "@fluentui/react-components";
import RichTextEditor from "../../../shared/components/RichTextEditor";
import Files from "../../files/components/Files";
import TicketUpdateCard from "../../ticketUpdates/components/TicketUpdateCard";
import TicketNoteEditor from "../../ticketUpdates/components/TicketNoteEditor";
import TicketMailEditor from "../../ticketUpdates/components/TicketMailEditor";

const TicketEditorConversations = ({
  conversationRef,
  newTicket,
  CurrentTicket,
  updateField,
  attachmentsRef,
  ticketUpdatesData,
  t,
  setShowEditor,
  setShowMailEditor,
  setEditorValue,
  showEditor,
  //editorValue,
  updateLanguage,
  setUpdateLanguage,
  hasScrollbar,
  showMailEditor,
  mailProperties,
  setMailProperties,
  onEmailReply,
}) => {
  const handleNoteEditorClose = (e, data) => {
    if (!data.open) {
      setTimeout(() => setShowEditor(false), 300);
    } else {
      setShowEditor(true);
    }
  };

  const handleMailEditorClose = (e, data) => {
    if (!data.open) {
      setTimeout(() => setShowMailEditor(false), 300);
    } else {
      setShowMailEditor(true);
    }
  };

  return (
    <div
      id="conversation"
      ref={conversationRef}
      className="scrollable-container"
      style={{
        display: "flex",
        flex: 1,
        flexDirection: "column",
        gap: 0,
        padding: "10px",
        minHeight: 0,
        overflowY: "auto",
      }}
    >
      <div
        id="updates"
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
        }}
      >
        {/* NEW NOTE FOR NEW TICKET */}
        {newTicket && (
          <div id="new-note-for-new-ticket" style={{ border: `1px solid ${tokens.colorNeutralStroke1}` }}>
            <RichTextEditor
              value={CurrentTicket?.description || ""}
              selectedLanguage={CurrentTicket?.language}
              onChange={(content) => updateField("description", content)}
              onLanguageChange={(language) => updateField("language", language)}
              placeholder={t("generic.description")}
            />
            <Files ref={attachmentsRef} entity_type="ticket_update" editable />
          </div>
        )}
        {ticketUpdatesData?.map((ticketUpdate, index) => (
          <TicketUpdateCard key={ticketUpdate.id} ticketUpdate={ticketUpdate} onEmailReply={onEmailReply} />
        ))}
      </div>
      <div
        style={{
          position: "sticky",
          bottom: 0,
          width: "100%",
          marginTop: "20px",
          paddingTop: hasScrollbar ? "20px" : "0px",
          backgroundColor: "white",
          paddingBottom: "8px",
          zIndex: 1,
        }}
      >
        {/* NEW NOTE FOR EXISTING TICKET */}
        <TicketNoteEditor
          ticketUpdate={{ ticket_id: CurrentTicket?.id }}
          isOpen={showEditor}
          onOpenChange={handleNoteEditorClose}
          //value={editorValue}
          selectedLanguage={updateLanguage}
          onLanguageChange={setUpdateLanguage}
          placeholder={t("generic.addUpdate", { defaultValue: "Add an update..." })}
          onSend={(content, pendingAttachments) => {
            setEditorValue("");
            setUpdateLanguage("");
          }}
        />
        {CurrentTicket?.id && (
          <TicketMailEditor
            ticket={CurrentTicket}
            mailProperties={mailProperties}
            setMailProperties={setMailProperties}
            //value={editorValue}
            onChange={setEditorValue}
            toAddress={mailProperties?.to}
            subject={
              mailProperties?.subject ?? `[#${CurrentTicket?.type}-${CurrentTicket?.id}] ${CurrentTicket?.title}`
            }
            placeholder={t("generic.emailContent", { defaultValue: "Enter email content..." })}
            selectedLanguage={updateLanguage}
            onLanguageChange={setUpdateLanguage}
            isOpen={showMailEditor}
            onOpenChange={handleMailEditorClose}
            onClose={() => {
              setMailProperties(null);
              setEditorValue(null);
              setUpdateLanguage("");
              setTimeout(() => setShowMailEditor(false), 300);
            }}
          />
        )}
      </div>
    </div>
  );
};

export default TicketEditorConversations;
